import script from "./AppointmentSurveyForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentSurveyForm.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentSurveyForm.vue?vue&type=style&index=0&id=563d113d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563d113d"]])

export default __exports__